<template>
    <div class="box center filterContent">
        <div class="flex">
            <div class="flex1"> 
                    <p class="small_font">总积分</p>
                    <p class="big_font">{{ score.total }}</p>
            </div>
        </div>
        <div class="flex" style="margin-top: 0.07rem;">
            <div class="left flex1"> 
                <p class="nomal_font">{{ score.indirect }}</p>
                <p class="small_font">努力积分</p>
            </div>
            <div class="border"></div>
            <div class="right flex1">
                <p class="nomal_font">{{ score.direct }}</p>
                <p class="small_font">躺赚积分</p>
            </div>
        </div>
        <br />
    </div>
</template>

<script>

export default {
  props: ['score'],
  name: 'Header'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.filterContent {
    height: unset;
}
</style>



// WEBPACK FOOTER //
// src/components/userScoreElement/Header.vue